import styled from 'styled-components';

export const InformationSpan = styled.span`
  color: ${({ theme }) => theme.pallete.placeholderText};
  font-size: 0.9rem;
  line-height: 1.6rem;
}`;
